import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJson from "./en.json"
import spJson from "./sp.json"
import frJson from "./fr.json"
import deJson from "./de.json"

i18n
    .use(initReactI18next)
    .init({
        lng: "en",
        fallbackLng: "en",
        resources: {
            en: {
                translation: { // when adding new engravings, they also need to be added to engravingDetails with a description in order to show up
                    "ENGRAVINGS": enJson,
                    "UI": {
                        "nowInSpanish": "Now available in German! All build information has been updated!",
                        "Engraving_Search": "Engraving Search",
                        "Top_Engravings": "Top Engravings",
                        "Builds": "Builds",
                        "Settings": "Settings",
                        "Select_Your_Engravings": "Select Your Engravings",
                        "Perfect_Matches": "Perfect Matches",
                        "Partial_Matches": "Partial Matches",
                        "No_Match": "No Matches",
                        "Most_Popular_Engravings": "Most Popular Engravings",
                        "Useless_Engravings": "Useless Engravings",
                        "Used_For": "used in"
                    },
                    "STATS": {
                        "Specialization": "Specialization",
                        "Swiftness": "Swiftness",
                        "Crit": "Crit",
                        "Domination": "Domination",
                        "Endurance": "Endurance",
                        "Expertise": "Expertise"
                    },
                    "BUILD_NAMES": {
                        "Mayhem_Berserker": "Mayhem Berserker",
                        "Technique_Berserker": "Technique Berserker",
                        "Blue_Warlord_Gunlancer": "Blue Warlord Gunlancer",
                        "Red_Warlord_Gunlancer": "Red Warlord Gunlancer",
                        "Judgement_Paladin": "Judgement Paladin",
                        "Blessing_Paladin": "Aura of Blessing Paladin",
                        "Deathblow_Striker": "Deathblow Striker",
                        "Esoteric_Flurry_Striker": "Esoteric Flurry Striker",
                        "Robust_Spirit_Soulfist": "Robust Spirit Soulfist",
                        "Energy_Overflow_Soulfist": "Energy Overflow Soulfist",
                        "Taijutsu_Scrapper": "Taijutsu Scrapper",
                        "Shock_Training_Scrapper": "Shock Training Scrapper",
                        "Esoteric_Wardancer": "Esoteric Wardancer",
                        "First_Intention_Wardancer": "First Intention Wardancer",
                        "Enhanced_Weapon_Deadeye": "Enhanced Weapon Deadeye",
                        "Pistoleer_Deadeye": "Pistoleer Deadeye",
                        "Death_Strike_Sharpshooter": "Death Strike Sharpshooter",
                        "Loyal_Companion_Sharpshooter": "Loyal Companion Sharpshooter",
                        "Death_Strike_Companion_Sharpshooter": "Death Strike + Companion Sharpshooter",
                        "Firepower_Enhancement_Artillerist": "Firepower Enhancement Artillerist",
                        "Barrage_Enhancement_Artillerist": "Barrage Enhancement Artillerist",
                        "Peacemaker_Gunslinger": "Peacemaker Gunslinger",
                        "Time_To_Hunt_Gunslinger": "Time To Hunt Gunslinger",
                        "Remaining_Energy_Deathblade": "Remaining Energy Deathblade",
                        "Surge_Deathblade": "Surge Deathblade",
                        "Perfect_Suppression_Shadowhunter": "Perfect Suppression Shadowhunter",
                        "Demonic_Impulse_Shadowhunter": "Demonic Impulse Shadowhunter",
                        "True_Courage_Bard": "True Courage Bard",
                        "Desperate_Salvation_Bard": "Desperate Salvation Bard",
                        "Igniter_Sorceress": "Igniter Sorceress",
                        "Reflux_Sorceress": "Reflux Sorceress",
                        "Pinnacle_Glavier": "Pinnacle Glaivier",
                        "Control_Glavier": "Control Glaivier",
                        "Hammer_Of_Rage_Destroyer": "Hammer of Rage Destroyer",
                        "Gravity_Training_Destroyer": "Gravity Training Destroyer",
                        "Empress_Grace_Arcanist": "Empress Grace Arcanist",
                        "Order_Of_The_Emperor_Arcanist": "Order of the Emperor Arcanist",
                        "Jiudau_Arcanist": "Jiudau Arcanist",
                        "Arthetinean_Mechanist": "Arthetinean Mechanist",
                        "Evolutionary_Legacy_Mechanist": "Evolutionary Legacy Mechanist",
                        "Moon_Reaper": "Moon Reaper",
                        "Blood_Reaper": "Blood Reaper"
                    }
                }
            },
            sp: {
                translation: {
                    "ENGRAVINGS": spJson,
                    "UI": {
                        "nowInSpanish": "Ahora en Español",
                        "Engraving_Search": "Búsqueda de Grabados",
                        "Top_Engravings": "Top Grabados",
                        "Builds": "Builds",
                        "Settings": "Ajustes",
                        "Select_Your_Engravings": "Selecciona Tus Grabados",
                        "Perfect_Matches": "Coincidencias Perfectas",
                        "Partial_Matches": "Coincidencias Parciales",
                        "No_Match": "Nada Encontrado",
                        "Most_Popular_Engravings": "Grabados Más Populares",
                        "Useless_Engravings": "Grabados inútiles",
                        "Used_For": "usado para"
                    },
                    "STATS": {
                        "Specialization": "Especialización",
                        "Swiftness": "Rapidez",
                        "Crit": "Crítico",
                        "Domination": "Dominación",
                        "Endurance": "Resistencia",
                        "Expertise": "Dominio"
                    },
                    "BUILD_NAMES": {
                        "Mayhem_Berserker": "Mayhem Berserker",
                        "Technique_Berserker": "Technique Berserker",
                        "Blue_Warlord_Gunlancer": "Blue Warlord Gunlancer",
                        "Red_Warlord_Gunlancer": "Red Warlord Gunlancer",
                        "Judgement_Paladin": "Judgement Paladin",
                        "Blessing_Paladin": "Aura of Blessing Paladin",
                        "Deathblow_Striker": "Deathblow Striker",
                        "Esoteric_Flurry_Striker": "Esoteric Flurry Striker",
                        "Robust_Spirit_Soulfist": "Robust Spirit Soulfist",
                        "Energy_Overflow_Soulfist": "Energy Overflow Soulfist",
                        "Taijutsu_Scrapper": "Taijutsu Scrapper",
                        "Shock_Training_Scrapper": "Shock Training Scrapper",
                        "Esoteric_Wardancer": "Esoteric Wardancer",
                        "First_Intention_Wardancer": "First Intention Wardancer",
                        "Enhanced_Weapon_Deadeye": "Enhanced Weapon Deadeye",
                        "Pistoleer_Deadeye": "Pistoleer Deadeye",
                        "Death_Strike_Sharpshooter": "Death Strike Sharpshooter",
                        "Loyal_Companion_Sharpshooter": "Loyal Companion Sharpshooter",
                        "Death_Strike_Companion_Sharpshooter": "Death Strike Companion Sharpshooter",
                        "Firepower_Enhancement_Artillerist": "Firepower Enhancement Artillerist",
                        "Barrage_Enhancement_Artillerist": "Barrage Enhancement Artillerist",
                        "Peacemaker_Gunslinger": "Peacemaker Gunslinger",
                        "Time_To_Hunt_Gunslinger": "Time To Hunt Gunslinger",
                        "Remaining_Energy_Deathblade": "Remaining Energy Deathblade",
                        "Surge_Deathblade": "Surge Deathblade",
                        "Perfect_Suppression_Shadowhunter": "Perfect Suppression Shadowhunter",
                        "Demonic_Impulse_Shadowhunter": "Demonic Impulse Shadowhunter",
                        "True_Courage_Bard": "True Courage Bard",
                        "Desperate_Salvation_Bard": "Desperate Salvation Bard",
                        "Igniter_Sorceress": "Igniter Sorceress",
                        "Reflux_Sorceress": "Reflux Sorceress",
                        "Pinnacle_Glavier": "Pinnacle Glaivier",
                        "Control_Glavier": "Control Glaivier",
                        "Hammer_Of_Rage_Destroyer": "Hammer of Rage Destroyer",
                        "Gravity_Training_Destroyer": "Gravity Training Destroyer",
                        "Empress_Grace_Arcanist": "Empress Grace Arcanist",
                        "Order_Of_The_Emperor_Arcanist": "Order of the Emperor Arcanist",
                        "Jiudau_Arcanist": "Jiudau Arcanist",
                        "Arthetinean_Mechanist": "Arthetinean Mechanist",
                        "Evolutionary_Legacy_Mechanist": "Evolutionary Legacy Mechanist",
                        "Moon_Reaper": "Moon Reaper",
                        "Blood_Reaper": "Blood Reaper"
                    }
                }
            },
            fr: {
                translation: {
                    "ENGRAVINGS": frJson,
                    "UI": {
                        "nowInSpanish": "Maintenant disponible en Espagnol et en rancais !",
                        "Engraving_Search": "Recherche de Gravure",
                        "Top_Engravings": "Gravures populaires",
                        "Builds": "Builds",
                        "Settings": "Réglages",
                        "Select_Your_Engravings": "Sélectionnez vos Gravures",
                        "Perfect_Matches": "Matchs parfaits",
                        "Partial_Matches": "Matchs partiels",
                        "No_Match": "No Matches", // missing in french
                        "Most_Popular_Engravings": "Gravures les plus populaires",
                        "Useless_Engravings": "Gravures inutiles",
                        "Used_For": "utilisé dans"
                        // need to add primary and secondary
                    },
                    "STATS": {
                        "Specialization": "Spécialisation",
                        "Swiftness": "Rapidité",
                        "Crit": "Critique",
                        "Domination": "Dominación",
                        "Endurance": "Resistencia",
                        "Expertise": "Dominio"
                    },
                    "BUILD_NAMES": {
                        "Mayhem_Berserker": "Mayhem Berserker",
                        "Technique_Berserker": "Technique Berserker",
                        "Blue_Warlord_Gunlancer": "Blue Warlord Gunlancer",
                        "Red_Warlord_Gunlancer": "Red Warlord Gunlancer",
                        "Judgement_Paladin": "Judgement Paladin",
                        "Blessing_Paladin": "Aura of Blessing Paladin",
                        "Deathblow_Striker": "Deathblow Striker",
                        "Esoteric_Flurry_Striker": "Esoteric Flurry Striker",
                        "Robust_Spirit_Soulfist": "Robust Spirit Soulfist",
                        "Energy_Overflow_Soulfist": "Energy Overflow Soulfist",
                        "Taijutsu_Scrapper": "Taijutsu Scrapper",
                        "Shock_Training_Scrapper": "Shock Training Scrapper",
                        "Esoteric_Wardancer": "Esoteric Wardancer",
                        "First_Intention_Wardancer": "First Intention Wardancer",
                        "Enhanced_Weapon_Deadeye": "Enhanced Weapon Deadeye",
                        "Pistoleer_Deadeye": "Pistoleer Deadeye",
                        "Death_Strike_Sharpshooter": "Death Strike Sharpshooter",
                        "Loyal_Companion_Sharpshooter": "Loyal Companion Sharpshooter",
                        "Death_Strike_Companion_Sharpshooter": "Death Strike Companion Sharpshooter",
                        "Firepower_Enhancement_Artillerist": "Firepower Enhancement Artillerist",
                        "Barrage_Enhancement_Artillerist": "Barrage Enhancement Artillerist",
                        "Peacemaker_Gunslinger": "Peacemaker Gunslinger",
                        "Time_To_Hunt_Gunslinger": "Time To Hunt Gunslinger",
                        "Remaining_Energy_Deathblade": "Remaining Energy Deathblade",
                        "Surge_Deathblade": "Surge Deathblade",
                        "Perfect_Suppression_Shadowhunter": "Perfect Suppression Shadowhunter",
                        "Demonic_Impulse_Shadowhunter": "Demonic Impulse Shadowhunter",
                        "True_Courage_Bard": "True Courage Bard",
                        "Desperate_Salvation_Bard": "Desperate Salvation Bard",
                        "Igniter_Sorceress": "Igniter Sorceress",
                        "Reflux_Sorceress": "Reflux Sorceress",
                        "Pinnacle_Glavier": "Pinnacle Glaivier",
                        "Control_Glavier": "Control Glaivier",
                        "Hammer_Of_Rage_Destroyer": "Hammer of Rage Destroyer",
                        "Gravity_Training_Destroyer": "Gravity Training Destroyer",
                        "Empress_Grace_Arcanist": "Empress Grace Arcanist",
                        "Order_Of_The_Emperor_Arcanist": "Order of the Emperor Arcanist",
                        "Jiudau_Arcanist": "Jiudau Arcanist",
                        "Arthetinean_Mechanist": "Arthetinean Mechanist",
                        "Evolutionary_Legacy_Mechanist": "Evolutionary Legacy Mechanist",
                        "Moon_Reaper": "Moon Reaper",
                        "Blood_Reaper": "Blood Reaper"
                    }
                }
            },
            de: {
                translation: {
                    "ENGRAVINGS": deJson,
                    "UI": {
                        "nowInSpanish": "Jetzt verfügbar auf spanisch, französisch und deutsch!",
                        "Engraving_Search": "Gravurensuche",
                        "Top_Engravings": "Top-Gravuren",
                        "Builds": "Builds",
                        "Settings": "Einstellungen",
                        "Select_Your_Engravings": "Wähle deine Gravuren",
                        "Perfect_Matches": "Perfekte Übereinstimmungen",
                        "Partial_Matches": "Teilweise Übereinstimmungen",
                        "No_Match": "Keine Übereinstimmung",
                        "Most_Popular_Engravings": "Beliebteste Gravuren",
                        "Useless_Engravings": "Nutzlose Gravuren",
                        "Used_For": "Benutzt in"
                    },
                    "STATS": {
                        "Specialization": "Spezialisierung",
                        "Swiftness": "Flinkheit",
                        "Crit": "Krit",
                        "Domination": "Beherrschung",
                        "Endurance": "Zähigkeit",
                        "Expertise": "Kompetenz"
                    },
                    "BUILD_NAMES": {
                        "Mayhem_Berserker": "Verwüstungs-Berserker",
                        "Technique_Berserker": "Technik des Berserkers Berserker",
                        "Blue_Warlord_Gunlancer": "Blauer Pistolenlanzer",
                        "Red_Warlord_Gunlancer": "Roter Pistolenlanzer",
                        "Judgement_Paladin": "Dps Paladin",
                        "Blessing_Paladin": "Support Paladin",
                        "Deathblow_Striker": "Todesstoß Striker",
                        "Esoteric_Flurry_Striker": "Esoterik Striker",
                        "Robust_Spirit_Soulfist": "Robuster Geist Seelenfaust",
                        "Energy_Overflow_Soulfist": "Übersprudelnde Energie Seelenfaust",
                        "Taijutsu_Scrapper": "Taijutsu Scrapper",
                        "Shock_Training_Scrapper": "Schockausbildung Scrapper",
                        "Esoteric_Wardancer": "Esoterik Kriegstänzer",
                        "First_Intention_Wardancer": "Erste Absicht Kriegstänzer",
                        "Enhanced_Weapon_Deadeye": "Verstärkte Waffe Todesschütze",
                        "Pistoleer_Deadeye": "Pistolier Todesschütze",
                        "Death_Strike_Sharpshooter": "Death Strike Sharpshooter",
                        "Loyal_Companion_Sharpshooter": "Loyal Companion Sharpshooter",
                        "Death_Strike_Companion_Sharpshooter": "Todesschlag-Gefährte Scharfschütze",
                        "Firepower_Enhancement_Artillerist": "Feuerkraftverstärkung Artillerist",
                        "Barrage_Enhancement_Artillerist": "Sperrfeuer Artillerist",
                        "Peacemaker_Gunslinger": "Friedensstifter Kunstschützin",
                        "Time_To_Hunt_Gunslinger": "Zeit für die Jagd Kunstschützin",
                        "Remaining_Energy_Deathblade": "Verbleibende Energie Todesklinge",
                        "Surge_Deathblade": "Bersten Todesklinge",
                        "Perfect_Suppression_Shadowhunter": "Perfekte Unterdrückung Schattenjägerin",
                        "Demonic_Impulse_Shadowhunter": "Dämonischer Impuls Schattenjägerin",
                        "True_Courage_Bard": "Dps Barde",
                        "Desperate_Salvation_Bard": "Support Barde",
                        "Igniter_Sorceress": "Zünder Zauberin",
                        "Reflux_Sorceress": "Rückfluss Zauberin",
                        "Pinnacle_Glavier": "Gipfel Lanzenträgerin",
                        "Control_Glavier": "Kontrolle Lanzenträgerin",
                        "Hammer_Of_Rage_Destroyer": "Zorneshammer Zerstörer",
                        "Gravity_Training_Destroyer": "Gravitationsausbildung Zerstörer",
                        "Empress_Grace_Arcanist": "Anmut der Kaiserin Arkanist",
                        "Order_Of_The_Emperor_Arcanist": "Befehl des Kaisers Arkanist",
                        "Jiudau_Arcanist": "Jiudau Arkanist",
                        "Arthetinean_Mechanist": "Arthetinische Fertigkeit Maschinist",
                        "Evolutionary_Legacy_Mechanist": "Erbe der Evolution Maschinist",
                        "Moon_Reaper": "Mond-Schnitter",
                        "Blood_Reaper": "Durst-Schnitter"
                    }
                }
            }
        }
    })
export default i18n;

